import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';
import { PartnerTypes } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class ReserveTaxiPartnerGuardService implements CanActivate, CanActivateChild {
  private _userService = inject(UserService);
  private router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const isAdvanced = this._userService.partnerType === PartnerTypes.PARTNER_ADVANCED;
    if (isAdvanced) {
      this.router.navigate(['/reserve-taxi-advanced']);
    }
    return !isAdvanced;
  }

  canActivateChild(_childRoute: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    return this.canActivate(null, null);
  }
}
